import {
  addCustomSources,
  addCustomLayers,
  addCOGMasks
} from './customLayerUtils.js';

/**
 * Sets up custom sources and layers on the map.
 * @param {maplibregl.Map} map
 * @param {Object} externalData
 */
export async function addCustomSourcesAndLayers(map, externalData) {
  const { sources, layers } = externalData;

  addCustomSources(map, sources);
  addCustomLayers(map, layers);

  // Map sources by name for quick lookup
  const sourceMap = Object.fromEntries(sources.map(s => [s.name, s]));

  // Collect valid raster COG sources only used in raster layers
  const rasterCOGSources = [];
  for (const layer of layers) {
    if (layer.type !== 'raster') continue;

    const source = sourceMap[layer.source];
    if (!source) continue;

    const tileUrl = source.tiles?.[0];
    const isCOG = source.type === 'raster' &&
                  tileUrl?.includes("/cog/tiles") &&
                  tileUrl.includes("url=");

    if (isCOG) {
      rasterCOGSources.push(source);
    }
  }

  if (rasterCOGSources.length > 0) {
    await addCOGMasks(map, rasterCOGSources, layers);
  }
}


